import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FlightSearchPayload } from '../models/flight-payload';
import { ViewFlightInfoSummary } from '../models/view-flight-info-model';
import { buildSummaryPathFromViewInfo } from './payload-mapper';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/dangerous-goods';
export interface TakeOwnershipRequest {
  origin: string;
  date: string;
  time: string;
  commodity: string;
  currentOwner: string;
  flightSuffix?: string;
  action?: string;
}
export interface CargoReleaseAck {
  acknowledgement: string;
}
export interface TakeOwnershipResponse {
  success: boolean;
  message: string;
  data?: {
    AcknowledgementMessage: string;
  };
}
@Injectable({
  providedIn: 'root',
})
export class ViewFlightInfoService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  protected mapPayload(payload: FlightSearchPayload) {
    return buildSummaryPathFromViewInfo(payload);
  }
  private splitFlightNumber(full: string): { num: string; sfx: string } {
    const match = /^(\d+)([A-Za-z]?)$/.exec(full);
    return {
      num: match ? match[1] : full,
      sfx: match?.[2] || '',
    };
  }

  getFlightSummaryViaUrl(base: FlightSearchPayload): Observable<ViewFlightInfoSummary> {
    const { urlPath, query } = this.mapPayload(base);

    let params = new HttpParams();
    if (query.commodityCode) params = params.set('commodityCode', query.commodityCode);
    if (query.origin) params = params.set('origin', query.origin);
    if (query.depDateTime) params = params.set('depDateTime', query.depDateTime);

    if (query.flightNoSfx) {
      params = params.set('flightNoSuffix', query.flightNoSfx);
    }

    params = params.set('fmLoadIndicator', String(query.fmLoadIndicator));

    const url = `${this.baseUrl}${urlPath}`;
    return this.http.get<ViewFlightInfoSummary>(url, { params });
  }
  takeOwnership(
    carrierCode: string,
    flightNumber: string,
    request: TakeOwnershipRequest
  ): Observable<TakeOwnershipResponse> {
    let url = `${environment.apiBaseUrl}/cafo/take-ownership/${carrierCode}/${flightNumber}`;

  

    return this.http.put<TakeOwnershipResponse>(url, request);
  }

  updateCargoRelease(
    carrierCode: string,
    flightNumber: string,
    payload: any
  ): Observable<ApiResponse<{ acknowledgement: string }>> {
    const url = `${this.baseUrl}/cdl/loadrelease/${carrierCode}/${flightNumber}`;

    return this.http.put<ApiResponse<{ acknowledgement: string }>>(url, payload);
  }
}
